module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/electrical-panel/electricalPanel.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/electrical-panel/electricalPanel.png
// module id = 560
// module chunks = 0